import React, { useEffect, useState } from "react";
import styles from "./portalApp.module.css";
import profileImg from "./images/graduation.jpg";
import {
  isTokenExpired,
  removeToken,
  getToken,
  decodeToken,
} from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import Marksheet from "./Marksheet";
import { useNavigate } from "react-router-dom";



const PortalApp = () => {
  const navigate = useNavigate();
  const [myProfile,setMyProfil]=useState([]);
  const token = getToken();
  const std_id = decodeToken(token, "id");
  console.log("stdid:", std_id);

  // 🧠 useState to store dynamic tab data
  const [tabData, setTabData] = useState({
    Lessons: [],
    Examination: [],
    Results: [],
    Marksheet: [
      { No: 1, Semester: "Semester 1", GPA: "3.8" },
      { No: 2, Semester: "Semester 2", GPA: "3.5" },
    ],
  });

  const [activeTab, setActiveTab] = useState("Lessons");

 useEffect(() => {
  const getData = async () => {
    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/getCourse`;
      const body = { std_id: std_id };
      const response = await postData(url, body);

      console.log("API Data:", response);

      // ✅ Dynamically extract keys & values from API data
      const lessonsData = response.data.map((item, index) => ({
        No: index + 1,
        ...item, // spread all key-value pairs dynamically
      }));

      // ✅ Update tabData dynamically
      setTabData((prev) => ({
        ...prev,
        Lessons: lessonsData,
      }));

      console.log('Response test:', response.data);
      console.log('TabData:', tabData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getExam = async () => {
    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/ExamTime`;
      const body = { std_id: std_id };
      const response = await postData(url, body);

   

       // ✅ Dynamically extract keys & values
      const examData = response.data.map((item, index) => ({
        No: index + 1,
        ...item,
      }));

      setTabData((prev) => ({
        ...prev,
         Examination: examData, // change to different tab name if needed
      }));

      console.log('Response Exam:', response.data);
      
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  // Result for current semester
   const getResult = async () => {
    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-result`;
      const body = { std_id: std_id };
      const response = await postData(url, body);

   

       // ✅ Dynamically extract keys & values
      const resultData = response.data.map((item, index) => ({
        No: index + 1,
        ...item,
      }));

      setTabData((prev) => ({
        ...prev,
          Results: resultData, // change to different tab name if needed
      }));

      console.log('Response Result:', response.data);
      
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };




   const getStudentProfile = async () => {
    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-myProfile`;
      const body = { std_id: std_id };
      const response = await postData(url, body);

   

       // ✅ Dynamically extract keys & values
       setMyProfil(response.data);
       console.log('my profile:',myProfile);

       

      console.log('Student Profile:', response.data);
      console.log('Student Name',[myProfile[0]?.['Name']])
      
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  if (std_id) {
    getData();
    getExam(); // also call exam data
    getResult();
    getStudentProfile();
  }
}, [std_id]);

const handleEnterExam = (item) => {
    navigate("/questions", {
      state: {
        student_id: std_id,
        class_id: item["class_id~hide"],
        semester_id: item["semester_id~hide"],
        course_id: item["course_id~hide"],
        exam_type: item["exam_type~hide"],
        id:item['id~hide'],
      },
      
      
    });
  };



  const currentData = tabData[activeTab] || [];

  

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>Profile & {activeTab}</h1>

      <div className={styles.content}>
        {/* Left Profile */}
        <div className={styles.profile}>
          <h3>My Profile</h3>
          <img src={profileImg} alt="Profile" className={styles.profileImg} />
          <p>
            <strong>Name:</strong>  {myProfile[0]?.['Name']}
          </p>
          <p>
            <strong>Student ID:</strong>  {myProfile[0]?.['Student ID']}
          </p>
          <p>
            <strong>Program:</strong> {myProfile[0]?.['Program']}
          </p>
          <p>
            <strong>Class:</strong> {myProfile[0]?.['Class']}
          </p>
          <p>
            <strong>Semester:</strong> {myProfile[0]?.['Semester']}
          </p>
        </div>

        {/* Right Courses */}
        <div className={styles.courses}>
          <div className={styles.tabs}>
            {Object.keys(tabData).map((tab) => (
              <button
                key={tab}
                className={`${styles.tabBtn} ${
                  activeTab === tab ? styles.active : ""
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          <h4>{`My ${activeTab}`}</h4>
           {activeTab === "Marksheet" ? (
    <Marksheet studentId={std_id} />):

          currentData.length > 0 ? (
            <table className={styles.table}>
              <thead>
                <tr>
                  {Object.keys(currentData[0]).filter((key=>!key.includes('~hide')))
                  
                  .map((key) => (
                    <th key={key}>{key}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
      {currentData.map((item, index) => (
        <tr key={index}>
          {Object.keys(item)
            .filter((key) => !key.includes("~hide"))
            .map((key) => (
              <td key={key}>
                {key === "Chapters" ? (
                  <a
                    href={`/coursedetails/${item["course_id~hide"]}`} // ✅ access hidden key
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none", color: "blue" }}
                  >
                    {item[key]}
                  </a>
                ) : item[key] === "ontime" ? (
                  <button
                    onClick={() => handleEnterExam(item)}
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                  >
                    Enter Exam
                  </button>
                ) : (
                  item[key]
                )}
              </td>
            ))}
        </tr>
      ))}
    </tbody>
            </table>
          ) : (
            <p>No data available for {activeTab}.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PortalApp;
